import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;

    async function finish() {
      const { data, error } = await supabase?.auth?.getSession();
      if (!mounted) return;

      if (error) {
        navigate('/login', { replace: true });
        return;
      }

      if (data?.session) {
        navigate('/dashboard-overview', { replace: true });
      } else {
        navigate('/login', { replace: true });
      }
    }

    finish();

    return () => { mounted = false; };
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-text-primary">
      <div className="bg-card border border-border rounded-lg p-6">
        Signing you in…
      </div>
    </div>
  );
}
